module.exports = __webpack_public_path__ + "img/upload.6b1bfa25.svg";